const getMonthRange = (year, month) => {
  const monthNumber = Number(month);
  const yearNumber = Number(year);
  const lastDay = new Date(yearNumber, monthNumber, 0).getDate();
  const paddedMonth = String(monthNumber).padStart(2, '0');

  return {
    start: `${yearNumber}-${paddedMonth}-01`,
    end: `${yearNumber}-${paddedMonth}-${String(lastDay).padStart(2, '0')}`,
  };
};

const rangesOverlap = (startA, endA, startB, endB) => startA <= endB && endA >= startB;

export const getDiscountNoticesForMonth = (year, month, discounts = []) => {
  const { start: monthStart, end: monthEnd } = getMonthRange(year, month);

  return discounts
    .filter(({ start, end }) => rangesOverlap(start, end, monthStart, monthEnd))
    .map(({ text }) => text.trim())
    .filter(Boolean);
};
